import { createSagaActionTypes } from '../../../utils/actionFactory';

export const UPDATE_RANGE = 'UPDATE_RANGE';
export const SET_RANGES = 'SET_RANGES';

export const actions = createSagaActionTypes('MULTIEDIT_NUMBER_RANGE', [
  UPDATE_RANGE,
  SET_RANGES
]);
